import queryString from 'query-string';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { currencyFormat } from 'common/helpers/numberHelper';

const PriceFilter = (props) => {
  const { range } = props;

  const history = useHistory();
  const location = useLocation();
  const settings = useSelector((state) => state.setting);

  const queryObj = queryString.parse(location.search);
  const { fromPrice } = queryObj;

  const handleChange = (e) => {
    const ePrice = e.target.value;
    const parsed = queryString.parse(location.search);
    delete parsed.fromPrice;
    delete parsed.toPrice;
    if (ePrice !== '') {
      parsed.fromPrice = ePrice;
      const findPrice = priceArray.find((p) => p.fromPrice === ePrice);
      if (findPrice?.toPrice) {
        parsed.toPrice = findPrice.toPrice;
      }
    }
    delete parsed.page;
    const stringified = queryString.stringify(parsed);
    let url = location.pathname;
    if (stringified.length > 0) {
      url += `?${stringified}`;
    }
    history.push(url);
  };

  const priceArray = createPriceArray(range, settings);

  return (
    <>
      <div className="c7-selectbox">
        <label htmlFor="priceId">
          Price:
          <span className="c7-selectboxWrap">
            <select
              id="priceId"
              name="priceId"
              value={fromPrice}
              onChange={handleChange}
            >
              <option value="" />
              {priceArray.map((p) => (
                <option value={p.fromPrice} key={p.fromPrice}>
                  {p.label}
                </option>
              ))}
            </select>
          </span>
        </label>
      </div>
    </>
  );
};

const createPriceArray = (range, settings) => {
  const priceArray = [];
  const rangeArray = range.split(',');
  rangeArray.forEach((r, index) => {
    const toPrice = createInt(r);
    if (Number.isNaN(toPrice)) {
      throw new Error('Invalid Number');
    }
    let fromPrice = 0;
    if (index > 0) {
      fromPrice = createInt(rangeArray[index - 1]);
    }
    priceArray.push({
      fromPrice: `${fromPrice}`,
      toPrice: `${toPrice}`,
      label: `${currencyFormat(fromPrice, settings)} - ${currencyFormat(
        toPrice,
        settings
      )}`
    });
  });
  const fromPrice = createInt(rangeArray[rangeArray.length - 1]);
  priceArray.push({
    fromPrice: `${fromPrice}`,
    label: `${currencyFormat(fromPrice, settings)} or more`
  });
  return priceArray;
};

const createInt = (number) => {
  const int = parseFloat(number * 100, 10);
  return Math.round(int);
};

export default PriceFilter;
